import React from "react";
import { ExlyInput } from "common/form";
import { Field } from "react-final-form";
import { EXIT_INTENT_SETTINGS_CONFIG } from "./constants/ExitIntentFormFields.constants";
import { FormFieldLabel } from "features/Common/modules/Form/modules/FormFieldLabel/FormFieldLabel";
import { required } from "common/validate";

export const ExitIntentFormFields = () => {
  const { exit_intent_title, exit_intent_cta } = EXIT_INTENT_SETTINGS_CONFIG;
  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <Field
        name={exit_intent_title.key}
        placeholder={exit_intent_title.placeholder}
        label={
          <FormFieldLabel
            formKeys={EXIT_INTENT_SETTINGS_CONFIG}
            formKey={exit_intent_title.key}
            classes={{ labelClassName: "tw-mr-1" }}
            required
          />
        }
        size="small"
        component={ExlyInput}
        validate={required}
        fullWidth
      />
      <Field
        name={exit_intent_cta.key}
        placeholder={exit_intent_cta.placeholder}
        label={
          <FormFieldLabel
            formKeys={EXIT_INTENT_SETTINGS_CONFIG}
            formKey={exit_intent_cta.key}
            required
            classes={{ spanClassName: "tw-mr-1" }}
          />
        }
        size="small"
        component={ExlyInput}
        validate={required}
        fullWidth
      />
    </div>
  );
};
